import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SwipeService {
  private directionSource = new BehaviorSubject({
    direction: '',
    values: { x: 0, y: 0 },
  });
  public currentDirection$ = this.directionSource.asObservable();
  private swipeCoordinates: { x: number; y: number };
  private swipeTime: number;
  private directionValues: {
    direction: string;
    values: { x: number; y: number };
  };

  setDirection(directionValues: {
    direction: string;
    values: { x: number; y: number };
  }) {
    this.directionSource.next(directionValues);
  }

  public onSwipe(event: TouchEvent): void {
    const coordinates = {
      x: event.changedTouches[0].pageX,
      y: event.changedTouches[0].pageY,
    };
    const time = new Date().getTime();

    if (event.type === 'touchstart') {
      this.swipeCoordinates = coordinates;
      this.swipeTime = time;
      return;
    }

    if (event.type === 'touchend') {
      const move = {
        x: coordinates.x - this.swipeCoordinates.x,
        y: coordinates.y - this.swipeCoordinates.y,
      };
      const duration = time - this.swipeTime;

      if (
        !(duration < 1000 && (Math.abs(move.x) > 30 || Math.abs(move.y) > 30))
      ) {
        return;
      }
      if (Math.abs(move.x) > Math.abs(move.y * 3)) {
        this.directionValues =
          move.x < 0
            ? { direction: 'left', values: move }
            : { direction: 'right', values: move };
        this.setDirection(this.directionValues);
        return;
      }
      if (Math.abs(move.y) > Math.abs(move.x * 3)) {
        this.directionValues =
          move.y < 0
            ? { direction: 'top', values: move }
            : { direction: 'bottom', values: move };
        this.setDirection(this.directionValues);
      }
    }
  }
}
